import React, { FC, useCallback, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { clsx, Colors, CoreButton, RainbowButton, Showable, useStyles } from '@sweatpals/react-ui-kit';
import { observer } from 'mobx-react-lite';
import { authStore } from 'stores';
import { headerNavStyles } from './header-nav.styles';
import ExternalLink from '../../links/External-link';
import useLink from '../../../utils/hooks/useLink';
import { isClient } from '../../../constants';
import UserProfileMenu from '../user-profile-menu/user-profile-menu.component';
import { AccountMenuIcon } from '../../icons';
import UserAvatar from '../../images/UserAvatar';

export interface HeaderNavProps {
	authText?: string;
	redirectBackOnLogin?: boolean;
	onAuthClick?(): void;
}

export const HeaderNav: FC<HeaderNavProps> = observer(props => {
	const { onAuthClick, authText, redirectBackOnLogin } = props;
	const [isUserMenuOpen, setUserMenuVisibility] = useState(false);
	const anchorRef = useRef<HTMLDivElement | null>(null);

	const currentUser = authStore.user;

	const { makeDashboardLink } = useLink();

	const loginLinkWithRedirect = `${makeDashboardLink()}/auth/login${
		redirectBackOnLogin ? `?redirect=${isClient ? window.location.href : ''}` : ''
	}`;

	const styles = useStyles(headerNavStyles);

	const handleCloseUserMenu = useCallback(() => {
		setUserMenuVisibility(false);
	}, []);

	const handleOpenUserMenu = useCallback(() => {
		setUserMenuVisibility(true);
	}, []);

	return (
		<Box component='nav' sx={styles.root}>
			<Box component='ul' sx={styles.list}>
				<ExternalLink href='/create/event'>
					<RainbowButton sx={clsx(styles.launchEventButton)}>🚀 Launch an event</RainbowButton>
				</ExternalLink>

				<Showable show={!currentUser}>
					<ExternalLink href={loginLinkWithRedirect} target={redirectBackOnLogin ? '_self' : '_blank'} onClick={onAuthClick}>
						<CoreButton sx={clsx(styles.hostLoginButton)}>{authText || 'Host Login'}</CoreButton>
					</ExternalLink>
				</Showable>

				<Showable show={currentUser}>
					<Box
						sx={styles.accountWrapper}
						ref={anchorRef}
						onClick={handleOpenUserMenu}
					>
						<UserAvatar user={currentUser} />
						<Typography sx={styles.accountName}>
							{currentUser?.fullName}
						</Typography>
						<AccountMenuIcon style={{ color: Colors['737373'] }} />
					</Box>
				</Showable>
			</Box>
			<UserProfileMenu
				open={isUserMenuOpen}
				anchorRef={anchorRef}
				onClose={handleCloseUserMenu}
			/>
		</Box>
	);
});

export default HeaderNav;
